import type { ToastInput } from '@agentic/ui-kit';

type Listener = (toast: ToastInput | { error: unknown; title?: string }) => void;
const listeners = new Set<Listener>();

/**
 * Bridge from non-React code (query cache, api client) to the toast provider. `ToastBridge` subscribes.
 */
export const notify = {
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  toast(toast: ToastInput): void {
    for (const l of listeners) l(toast);
  },
  error(error: unknown, title?: string): void {
    for (const l of listeners) l(title === undefined ? { error } : { error, title });
  },
};
